import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment.dev';
import { Environment } from '@env/environment.model';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  private readonly document = inject(DOCUMENT);

  get env(): Environment {
    return environment;
  }

  get isProduction(): boolean {
    return this.env.production;
  }

  get appVersion(): string {
    return this.env.appVersion;
  }

  get mixpanel() {
    return this.env.mixpanel;
  }

  get apiBaseUrl(): string {
    return this.env.api.baseUrl;
  }

  get intercomId(): string {
    return this.env.intercomAppId;
  }

  get currentLocation(): Location {
    return this.document.location;
  }

  get currentDomain(): string {
    return this.document.location.origin;
  }
}
